import React from "react";
import { useNavigate } from "react-router-dom";
import { Create } from "adminApi/SalaryGenerateApi/SalaryGenerate";
import Spinner from "Common/Globle/Spinner";
import AddSalaryGenerateForm from "./components/AddSalaryGenerateForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { SalaryGenerateRules } from "validation/ValidationRules";
import { validateForm } from "utils/validation";
import fields from "../json/SalaryGenerate.json";

/**
 * AddSalaryGenerate
 * 
 * Following the EXACT "Code Flow" of SalaryType/AddSalaryType.jsx:
 */
const AddSalaryGenerate = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // Initialize form values dynamically
    const initialValues = formdata.reduce((acc, field) => {
        acc[field.name] = field.name === "pay_frequency" ? "monthly" : "" || field.name === "status" ? "generated" : "";
        return acc;
    }, {});

    const {
        values,
        errors,
        handleChange,
        setErrors
    } = useFormChange(initialValues, SalaryGenerateRules);

    const { loading, handleSubmit } = useFormSubmit(
        async (formValues) => {
            // Prepare FormData for the backend API
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            return await Create({ data: formData });
        },
        (vals) => {
            // Client-side validation before submission
            const err = validateForm(vals, SalaryGenerateRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Salary Sheets were generated successfully"
    );

    return (
        <>
            {loading && <Spinner isSpinner />}
            <AddSalaryGenerateForm
                fields={fields}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loading}
                title="Add Salary Generate"
            />
        </>
    );
};

export default AddSalaryGenerate;
